import React from 'react';
import axios from 'axios';
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField';
import './WhatIf.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import { TableCell, tableCellClasses } from '@mui/material'
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import AST from './FFXIVIcons/JOBS/Astrologian.png';
import SCH from './FFXIVIcons/JOBS/Scholar.png';
import RPR from './FFXIVIcons/JOBS/Reaper.png';
import MNK from './FFXIVIcons/JOBS/Monk.png';
import NIN from './FFXIVIcons/JOBS/Ninja.png';
import PCT from './FFXIVIcons/JOBS/Pictomancer.png';
import RDM from './FFXIVIcons/JOBS/RedMage.png';
import DRG from './FFXIVIcons/JOBS/Dragoon.png';
import SMN from './FFXIVIcons/JOBS/Summoner.png';
import BRD from './FFXIVIcons/JOBS/Bard.png';
import DNC from './FFXIVIcons/JOBS/Dancer.png';
import Div from "./FFXIVIcons/Divination.png";
import Play from "./FFXIVIcons/Play_I.png";
import ChainStratagem from "./FFXIVIcons/Chain_Stratagem.png";
import ArcaneCircle from "./FFXIVIcons/Arcane_Circle.png";
import Brotherhood from "./FFXIVIcons/Brotherhood.png";
import Dokumori from "./FFXIVIcons/Dokumori.png";
import BattleLitany from "./FFXIVIcons/Battle_Litany.png";
import Embolden from "./FFXIVIcons/Embolden.png";
import StarryMuse from "./FFXIVIcons/Starry_Muse.png";
import SearingLight from "./FFXIVIcons/Searing_Light.png";
import BattleVoice from "./FFXIVIcons/Battle_Voice.png";
import RadiantFinale from "./FFXIVIcons/Radiant_Finale.png";
import Paeon from "./FFXIVIcons/Army's_Paeon.png";
import Ballad from "./FFXIVIcons/Mage's_Ballad.png";
import Minuet from "./FFXIVIcons/The_Wanderer's_Minuet.png";
import TechStep from "./FFXIVIcons/Technical_Step.png";
import StandardStep from "./FFXIVIcons/Standard_Step.png";
import Devilment from "./FFXIVIcons/Devilment.png";

class WhatIf extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      players: [],
      duration: 0,
      buffs: {
        "Divination": false,
        "Play": false,
        "ChainStratagem": false,
        "ArcaneCircle": false,
        "Brotherhood": false,
        "Dokumori": false,
        "BattleLitany": false,
        "Embolden": false,
        "StarryMuse": false,
        "SearingLight": false,
        "BattleVoice": false,
        "RadiantFinale": false,
        "Paeon": false,
        "Ballad": false,
        "Minuet": false,
        "TechStep": false,
        "StandardStep": false,
        "Devilment": false
      },
      buffs_enum: {
        "Divination": 1.06,
        "Play": 1.06,
        "ChainStratagem": 1.05,
        "ArcaneCircle": 1.05,
        "Brotherhood": 1.05,
        "Dokumori": 1.05,
        "BattleLitany": 1.05,
        "Embolden": 1.05,
        "StarryMuse": 1.05,
        "SearingLight": 1.05,
        "BattleVoice": 1.05,
        "RadiantFinale": 1.06,
        "Paeon": 1.0075,
        "Ballad": 1.01,
        "Minuet": 1.01,
        "TechStep": 1.05,
        "StandardStep": 1.05,
        "Devilment": 1.15
      },
      parseFetch: false,
      selected_player: {},
      rdps: 0,
      buffs_mult: 1,
      rdps_initial: 0,
      manual_calc: 0,
      fetching: false,
      encounterID: 0,
      auth: null,
      kill: false,
      rank: 0,
      parse: null,
      rankings: [],
      totalParses: 1000,

    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleManualMult = this.handleManualMult.bind(this);
    this.manualCalc = this.manualCalc.bind(this);
    this.handleSelectPlayer = this.handleSelectPlayer.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();

    this.formSubmit(event.target);
  }

  //rankings(fightIDs: ` + fightID + `, playerMetric: rdps)
  async fflogsquery(auth, fightID, reportID) {

    var param = {
      query: `
        query {
          reportData {
            report(code: "` + reportID + `"){
              rankings(fightIDs: ` + fightID + `, playerMetric: rdps)
              table(fightIDs: ` + fightID + `, dataType: DamageDone)
              fights(fightIDs: ` + fightID + `) {
                encounterID
              }
            }
          }
        }`
    }
    await axios.get('https://www.fflogs.com/api/v2/client', {
      headers: {
        'Authorization': 'Bearer ' + auth,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      params: param
    }).then(async response => {
      this.setState({ fetching: false })
      try {
        const players = response.data.data.reportData.report.table.data.entries;
        const kill = response.data.data.reportData.report.rankings.data[0];
        var duration = 0;
        if (response.data.data.reportData.report.table.data.downtime)
          duration = (response.data.data.reportData.report.table.data.combatTime - (response.data.data.reportData.report.table.data.downtime)) / 1000;
        else {
          duration = response.data.data.reportData.report.table.data.combatTime
        }
        var totalRDPS = 0;
        if (kill) {
          var name = kill.roles.dps.characters[0].name;
          players.forEach((char) => {
            if (char.name == name) {
              totalRDPS = char.totalRDPS;
            }
          })
          duration = totalRDPS / kill.roles.dps.characters[0].amount;
          this.setState({ kill: true })
          players.forEach((player) => {
            kill.roles.dps.characters.forEach((char) => {
              if (char.name == player.name && !char.class_2) {
                player['totalParses'] = char.totalParses
              }
            })
            kill.roles.healers.characters.forEach((char) => {
              if (char.name == player.name && !char.class_2) {
                player['totalParses'] = char.totalParses
              }
            })
            kill.roles.tanks.characters.forEach((char) => {
              if (char.name == player.name && !char.class_2) {
                player['totalParses'] = char.totalParses
              }
            })
          })
        }
        else {
          this.setState({ kill: false })
        }
        var playerlist = [];
        var encounterID = response.data.data.reportData.report.fights[0].encounterID;
        players.forEach((player) => { if (player.type != "LimitBreak") { playerlist.push(player) }; })
        this.setState({ players: playerlist, duration: duration, encounterID: encounterID }, () => {
          document.getElementById("playerdiv").style.display = "block";
        });
      }
      catch (err) {
        console.log(err)
        return
      }
    });
  }

  async formSubmit(formData) {
    var data = new FormData(formData)
    try {
      this.setState({ fetching: true });
      var link = new URL(data.get("fflogs_link"));
      var reportID = link.pathname.split("/")[2]
      var fightID = link.search.split("&")[0].split("=")[1]
      link.toJSON();
      await axios.post('https://www.fflogs.com/oauth/token',
        new URLSearchParams({
          'grant_type': 'client_credentials'
        }),
        {
          auth: {
            username: process.env.REACT_APP_FFLOGS_CLIENT,
            password: process.env.REACT_APP_FFLOGS_SECRET
          }
        }).then(response => {
          this.setState({ auth: response.data.access_token })
          this.fflogsquery(response.data.access_token, fightID, reportID)
        })
    }
    catch (err) {
      console.log(err);
      this.setState({ fetching: false });
      return;
    }
  }

  autoSetBuffs() {
    var Allbuffs = document.querySelectorAll('[name*=Buffs]')
    var buffs = this.state.buffs;
    Allbuffs.forEach((buff) => {
      buffs[buff.id] = false;
      buff.style.opacity = 0.1;
    })
    this.setState({ buffs: buffs }, () => {
      var players = this.state.players;
      players.forEach((player) => {
        if (this.state.selected_player.name == player.name) {
          if (document.getElementById(player.type)) {
            document.getElementById(player.type).style.opacity = 0.1;
          }
          return;
        }

        if (document.getElementById(player.type)) {
          document.getElementById(player.type).style.opacity = 1;
        }
        this.handleJobSelect(player.type + "Buffs", true)
      })
    });
  }

  handleSelectPlayer(player) {
    var totalParses = 1000;
    if (this.state.kill)
      totalParses = player.totalParses;
    this.setState({ selected_player: player, rdps_initial: player.totalRDPS / this.state.duration, totalParses: totalParses }, () => {
      document.getElementById('calculator').style.display = 'block';
      this.autoSetBuffs();
      this.getRankings();
    })
  }

  async getRankings() {
    this.setState({ parseFetch: true })
    var pages = 10;
    if (this.state.kill) {
      pages = Math.ceil(this.state.selected_player.totalParses / 100)
    }
    var query = "";
    for (let i = 0; i < pages && i < 50; i++) {
      query += `page` + (i + 1) + `: characterRankings(includeCombatantInfo: true, specName: "` + this.state.selected_player.type + `", page: ` + (i + 1) + `) `
    }
    var param = {
      query: `
          query {
            worldData {
              encounter(id: ` + this.state.encounterID + `){
                ` + query + `

              }
            }
          }`
    }
    try {
      await axios.get('https://www.fflogs.com/api/v2/client', {
        headers: {
          'Authorization': 'Bearer ' + this.state.auth,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        params: param
      }).then((res) => {
        const encounter = res.data.data.worldData.encounter;
        var rankings = [];
        for (const [key, value] of Object.entries(encounter)) {
          rankings.push.apply(rankings, encounter[key].rankings)
        }
        this.setState({ rankings: rankings, parseFetch: false }, () => {
          this.calculateRank();
        });
      })
    }
    catch (err) {
      this.setState({ parseFetch: false });
      console.log(err)
    }

  }

  calculateRank() {
    var rank = 1;
    this.state.rankings.some((trank) => {
      if (parseFloat(trank.rDPS).toFixed(4) > parseFloat(this.state.rdps).toFixed(4)) {
        rank++;
      }
      else {
        return true;
      }
    })
    if (rank > 1000 && !this.state.kill) {
      var avgDiffPerParse = (this.state.rankings[0].rDPS - this.state.rankings[999].rDPS) / 1000
      var diffFrom1000 = this.state.rankings[999].rDPS - this.state.rdps;
      rank = rank + (diffFrom1000 / avgDiffPerParse);
    }
    else if (rank > 5000) {
      var avgDiffPerParse = (this.state.rankings[999].rDPS - this.state.rankings[4999].rDPS) / 4000
      var diffFrom1000 = this.state.rankings[4999].rDPS - this.state.rdps;
      rank = rank + (diffFrom1000 / avgDiffPerParse);
    }
    if (this.state.kill) {
      var parse = ((this.state.selected_player.totalParses - (rank - 1)) / this.state.selected_player.totalParses) * 100
      this.setState({ parse: parse }, () => {
        if (document.getElementById('parse')) {
          if (parse == 100) {
            document.getElementById('parse').style.color = '#f6e45d';
          }
          else if (parse >= 99) {
            document.getElementById('parse').style.color = '#ff88de';
          }
          else if (parse >= 95) {
            document.getElementById('parse').style.color = '#ffad31';
          }
          else if (parse >= 75) {
            document.getElementById('parse').style.color = '#a910f1';
          }
          else if (parse >= 50) {
            document.getElementById('parse').style.color = '#1f59e7';
          }
          else if (parse >= 25) {
            document.getElementById('parse').style.color = '#39e23d';
          }
          else {
            document.getElementById('parse').style.color = '#c9c9c9';
          }
        }

      })

    }
    rank = Math.ceil(rank);
    this.setState({ rank: rank })
  }

  handleCalculate(e) {
    var value = document.getElementById('DamageIncrease').value;
    value = value / this.state.buffs_mult;
    value += this.state.selected_player.totalRDPS;
    this.setState({ rdps: value / this.state.duration }, () => {
      this.calculateRank();
    })

  }

  buffsMultCalculate() {
    var totalMult = 1
    for (const [key, value] of Object.entries(this.state.buffs)) {
      if (this.state.buffs[key] == true) {
        totalMult *= this.state.buffs_enum[key];
      }
    }
    this.setState({ buffs_mult: totalMult }, () => {
      this.handleCalculate();
    })
  }

  handleBuffSelect(ID) {
    var opacity = window.getComputedStyle(document.getElementById(ID)).opacity;
    var buffs = this.state.buffs;
    if (opacity == 0.1)
      return;
    if (opacity == 0.25) {
      document.getElementById(ID).style.opacity = 1;
      buffs[ID] = true;
    }
    else {
      document.getElementById(ID).style.opacity = 0.25;
      buffs[ID] = false;
    }
    this.setState({ buffs: buffs }, () => {
      this.buffsMultCalculate();
    })

  }

  handleBuffSelectBRD(ID) {
    var opacity = window.getComputedStyle(document.getElementById(ID)).opacity;
    var buffs = this.state.buffs;
    if (opacity == 0.1)
      return;
    if (opacity == 0.25) {
      document.getElementById(ID).style.opacity = 1;
      buffs[ID] = true;
      var BardBuffs = document.getElementsByName('BardBuffsExtra');
      BardBuffs.forEach((buff) => {
        if (buff.id != ID) {
          buff.style.opacity = 0.25;
          buffs[buff.id] = false;
        }
      })

    }
    else {
      document.getElementById(ID).style.opacity = 0.25;
      buffs[ID] = false;
    }
    this.setState({ buffs: buffs }, () => {
      this.buffsMultCalculate();
    })

  }

  handleJobSelect(name, init) {
    var jobName = name.replace('Buffs', '');
    var job = document.getElementById(jobName);
    if (!job) {
      return;
    }
    if (init) {
      job.style.opacity = 1;
      if (jobName == 'Bard') {
        document.getElementById('Minuet').style.opacity = 0.25;
        this.handleBuffSelectBRD('Minuet');
      }
    }
    if (window.getComputedStyle(job).opacity == 0.1)
      return;
    var buffs = this.state.buffs;
    var buffsjobs = document.getElementsByName(name);
    var allEnabled = true;
    buffsjobs.forEach((buff) => {
      if (window.getComputedStyle(buff).opacity != 1) {
        allEnabled = false;
      }
    })
    if (allEnabled) {
      buffsjobs.forEach((buff) => {
        buff.style.opacity = 0.25
        buffs[buff.id] = false;
      })
    }
    else {
      buffsjobs.forEach((buff) => {
        buff.style.opacity = 1
        buffs[buff.id] = true;
      })
    }
    this.setState({ buffs: buffs }, () => {
      this.buffsMultCalculate();
    })
  }

  handleManualMult() {
    var value = document.getElementById('ManualMult').value;
    if (!value) {
      return;
    }
    this.setState({ buffs_mult: value }, () => {
      this.handleCalculate();
    });
  }
  manualCalc() {
    var totalRawDamage = document.getElementById('TotalRawDamage').value;
    var rawDPS = document.getElementById('RawDPS').value;
    var rDPS = document.getElementById('rDPS').value;
    var extraDamage = document.getElementById('ExtraDamage').value;
    var buffMult = document.getElementById('BuffMult').value;
    var duration = totalRawDamage / rawDPS;
    var newDPS = (rDPS * duration + extraDamage / buffMult) / duration
    this.setState({ manual_calc: newDPS })
  }

  render() {
    return (
      <div class="widget-post" aria- labelledby="post-header-title" style={{ margin: "25px" }}>
        <div class="widget-post__header">
          <h2 class="widget-post__title" id="post-header-title">
            <i class="fa fa-pencil" aria-hidden="true"></i>
            What if calculator
          </h2>
          Calculate your potential RDPS had you crit or done better. Breathe that copium in.
        </div>
        <div style={{ width: '50vw', marginTop: '10px' }}>
          <form onSubmit={this.handleSubmit} id="fflogs_link_form" autoComplete='off'>
            <TextField
              id="fflogs_link" label="Full fflogs link to kill/wipe log:" variant="standard" type="text" name="fflogs_link"
              sx={{ input: { color: '#5bc8fd', borderBottom: "2px solid #ffffff" }, label: { color: 'aliceblue' }, minWidth: '30vw', maxWidth: '200ch' }}
            />
            <Button style={{ marginLeft: "25px" }} variant="contained" id="submit" color="primary" type="submit">Search</Button>
          </form>
        </div>
        <div style={{ fontSize: "12px" }}>
          *FFLogs API doesn't provide the proper downtime values for wipe logs, as such, the actual DPS may be off. Wipe logs will also not include parses. Make sure the correct pull is selected and not last pull (should say fight=# and NOT fight=last).
        </div>
        {this.state.fetching === true && <LinearProgress sx={{ marginTop: "10px", maxWidth: "100ch" }} />}
        <div id="playerdiv" style={{ display: "none" }}>
          <TableContainer>
            <Table id="playertable" sx={{ minWidth: 650 }} aria-label="simple table" style={{ backgroundColor: 'none', color: 'white', }}>
              <TableHead>
                <TableRow>
                  {this.state.players.map((player) => {
                    return <TableCell sx={{ borderBottom: "none" }}><Button sx={{ color: 'aliceblue' }} variant="outlined" onClick={() => this.handleSelectPlayer(player)}>{player.name}</Button></TableCell>;
                  })}
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
        </div>

        <div id="calculator" style={{ paddingTop: '25px', fontSize: '28px', display: 'none' }}>
          <div style={{ marginBottom: "10px", fontSize: "16px" }}>
            Selected: {this.state.selected_player.name}
          </div>
          <div style={{ marginBottom: "25px", fontSize: "16px" }}>
            rDPS: {this.state.selected_player.totalRDPS / this.state.duration}
          </div>
          <div>Copium Injector</div>
          <div style={{ paddingTop: '25px', fontSize: '20px' }}>
            Buffs
            <div style={{ fontSize: "16px" }}>
              Do not include self buffs.
            </div>
            <TableContainer sx={{ maxWidth: 1200 }}>
              <Table sx={{
                [`& .${tableCellClasses.root}`]: {
                  borderBottom: "none",
                  opacity: 0.1

                }
              }} id="jobtable" aria-label="simple table" style={{ backgroundColor: 'none', color: 'white', }}>
                <TableHead>
                  <TableRow>
                    <TableCell id="Astrologian">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleJobSelect('AstrologianBuffs', false)} >
                        <img src={AST} width="50" alt="Astrologian" />
                      </Button>
                    </TableCell>
                    <TableCell id="Scholar">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleJobSelect('ScholarBuffs', false)}>
                        <img src={SCH} width="50" alt="Scholar" />
                      </Button>
                    </TableCell>
                    <TableCell id="Reaper">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleJobSelect('ReaperBuffs', false)}>
                        <img src={RPR} width="50" alt="Reaper" />
                      </Button>
                    </TableCell>
                    <TableCell id="Monk">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleJobSelect('MonkBuffs', false)}>
                        <img src={MNK} width="50" alt="Monk" />
                      </Button>
                    </TableCell>
                    <TableCell id="Ninja">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleJobSelect('NinjaBuffs', false)}>
                        <img src={NIN} width="50" alt="Ninja" />
                      </Button>
                    </TableCell>
                    <TableCell id="Dragoon">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleJobSelect('DragoonBuffs', false)}>
                        <img src={DRG} width="50" alt="Dragoon" />
                      </Button>
                    </TableCell>
                    <TableCell id="RedMage">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleJobSelect('RedMageBuffs', false)}>
                        <img src={RDM} width="50" alt="Red Mage" />
                      </Button>
                    </TableCell>
                    <TableCell id="Pictomancer">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleJobSelect('PictomancerBuffs', false)}>
                        <img src={PCT} width="50" alt="Pictomancer" />
                      </Button>
                    </TableCell>
                    <TableCell id="Summoner">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleJobSelect('SummonerBuffs', false)}>
                        <img src={SMN} width="50" alt="Summoner" />
                      </Button>
                    </TableCell>
                    <TableCell id="Bard">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleJobSelect('BardBuffs', false)}>
                        <img src={BRD} width="50" alt="Bard" />
                      </Button>
                    </TableCell>
                    <TableCell id="Dancer">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleJobSelect('DancerBuffs', false)}>
                        <img src={DNC} width="50" alt="Dancer" />
                      </Button>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody sx={{
                  minWidth: 650, [`& .${tableCellClasses.root}`]: {
                    borderBottom: "none",
                    paddingTop: 0,
                    paddingBottom: 0,
                    opacity: 0.1
                  }
                }}>
                  <TableRow>
                    <TableCell type="buffs" name="AstrologianBuffs" id="Divination" >
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('Divination')}>
                        <img src={Div} width="50" alt="Divination" />
                      </Button>
                    </TableCell>
                    <TableCell type="buffs" name="ScholarBuffs" id="ChainStratagem">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('ChainStratagem')}>
                        <img src={ChainStratagem} width="50" alt="Chain Stratagem" />
                      </Button>
                    </TableCell>
                    <TableCell type="buffs" name="ReaperBuffs" id="ArcaneCircle">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('ArcaneCircle')}>
                        <img src={ArcaneCircle} width="50" alt="Arcane Circle" />
                      </Button>
                    </TableCell>
                    <TableCell type="buffs" name="MonkBuffs" id="Brotherhood">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('Brotherhood')}>
                        <img src={Brotherhood} width="50" alt="Brotherhood" />
                      </Button>
                    </TableCell>
                    <TableCell type="buffs" name="NinjaBuffs" id="Dokumori">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('Dokumori')}>
                        <img src={Dokumori} width="50" alt="Dokumori" />
                      </Button>
                    </TableCell>
                    <TableCell type="buffs" name="DragoonBuffs" id="BattleLitany">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('BattleLitany')}>
                        <img src={BattleLitany} width="50" alt="Battle Litany" />
                      </Button>
                    </TableCell>
                    <TableCell type="buffs" name="RedMageBuffs" id="Embolden">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('Embolden')}>
                        <img src={Embolden} width="50" alt="Embolden" />
                      </Button>
                    </TableCell>
                    <TableCell type="buffs" name="PictomancerBuffs" id="StarryMuse">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('StarryMuse')}>
                        <img src={StarryMuse} width="50" alt="Starry Muse" />
                      </Button>
                    </TableCell>
                    <TableCell type="buffs" name="SummonerBuffs" id="SearingLight">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('SearingLight')}>
                        <img src={SearingLight} width="50" alt="Searing Light" />
                      </Button>
                    </TableCell>
                    <TableCell type="buffs" name="BardBuffs" id="RadiantFinale">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('RadiantFinale')}>
                        <img src={RadiantFinale} width="50" alt="Radiant Finale" />
                      </Button>
                    </TableCell>
                    <TableCell type="buffs" name="DancerBuffs" id="TechStep">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('TechStep')}>
                        <img src={TechStep} width="50" alt="Technical Step" />
                      </Button>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell type="buffs" name="AstrologianBuffs" id="Play" >
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('Play')}>
                        <img src={Play} width="50" alt="Play" />
                      </Button>
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell type="buffs" name="BardBuffs" id="BattleVoice">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('BattleVoice')}>
                        <img src={BattleVoice} width="50" alt="Battle Voice" />
                      </Button>
                    </TableCell>
                    <TableCell type="buffs" name="DancerBuffs" id="StandardStep">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('StandardStep')}>
                        <img src={StandardStep} width="50" alt="Standard Step" />
                      </Button>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell type="buffs" name="BardBuffsExtra" id="Minuet">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelectBRD('Minuet')}>
                        <img src={Minuet} width="50" alt="Minuet" />
                      </Button>
                    </TableCell>
                    <TableCell type="buffs" name="DancerBuffs" id="Devilment">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelect('Devilment')}>
                        <img src={Devilment} width="50" alt="Devilment" />
                      </Button>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell type="buffs" name="BardBuffsExtra" id="Paeon">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelectBRD('Paeon')}>
                        <img src={Paeon} width="50" alt="Paeon" />
                      </Button>
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell type="buffs" name="BardBuffsExtra" id="Ballad">
                      <Button variant="text" size="small" style={{ display: "flex", flexDirection: "column" }} onClick={() => this.handleBuffSelectBRD('Ballad')}>
                        <img src={Ballad} width="50" alt="Ballad" />
                      </Button>
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <div style={{ fontSize: "12px", marginBottom: "25px" }}>
              *Crit/Dhit buffs are estimated. Chain, Battle Litany & Battle Voice give ~ 5%. Devilment gives ~15%. Paeon gives ~0.75%. Minuet gives ~1%. Damage increase is roughly Crit/2 and Dhit/4. Manual xMult override available below.
            </div>
          </div>
          <div style={{ fontSize: "16px" }}>Set a value to see the results</div>
          <TextField
            id="DamageIncrease" label="Raw Damage Increase:" variant="standard" type="number" name="Damage Gain" onChange={(e) => this.handleCalculate(e)}
            sx={{ input: { color: 'aliceblue', borderBottom: "2px solid #ffffff", }, label: { color: 'aliceblue' }, maxWidth: '20ch' }} />
          <TextField
            id="ManualMult" label="Manual Mult override:" variant="standard" type="number" name="Buff Mult"
            sx={{ input: { color: 'aliceblue', borderBottom: "2px solid #ffffff", }, label: { color: 'aliceblue' }, maxWidth: '20ch', marginLeft: "250px" }} />
          <Button style={{ paddingLeft: "20px" }} variant="outlined" id="submit" color="primary" type="submit" onClick={this.handleManualMult}>Set</Button>

          <div style={{ fontSize: '16px', color: "#5bc8fd", marginTop: '5px' }}><Tooltip style={{ fontSize: '16px' }} title="Raw damage is the total damage added. i.e. if you hit an extra gcd, how much extra damage would that have done.
           Buff mult is the buff multiplier. e.g. two 5% buffs would be 1.05 * 1.05 = 1.1025x">What's this?</Tooltip></div>
          <div style={{ fontSize: "24px", paddingTop: "25px" }}>
            Buff Mult: {parseFloat(this.state.buffs_mult).toFixed(4)}x
          </div>
          <div style={{ fontSize: "24px", paddingTop: "5px", color: "#ec4775" }}>
            New rDPS: {parseFloat(this.state.rdps).toFixed(2)}
          </div>
          <div style={{ fontSize: "18px", paddingTop: "5px" }}>
            difference: {parseFloat(this.state.rdps - this.state.rdps_initial).toFixed(2)}
          </div>
          <div>
            {(!this.state.parseFetch) ? <div class='rank'> Rank: {this.state.rank}</div> : (<div>Fetching rank...<LinearProgress color='secondary' sx={{ marginTop: "10px", maxWidth: "10ch" }} /></div>)}
            {(!this.state.parseFetch && !this.state.kill) ? <div class='rank' style={{ fontSize: "12px" }}> *Non-kill ranks above 1000 are purely estimated based on a linear distribution, which is highly inaccurate. Non-enrage pull ranks should be ignored. </div> : null}
            {(this.state.kill && !this.state.parseFetch) ? (<div class='rank' >Parse: <text id='parse'>{parseFloat(this.state.parse).toFixed(2)}</text></div>) : null}
            {(!this.state.parseFetch && this.state.rank > 5000) ? <div style={{ fontSize: "12px" }}>*Ranks and parses are limited to 5000 due to request limits. Therefore, ranks and parses above 5000 are estimated and can be very inaccurate.</div> : null}
          </div>


        </div>
        <hr class="solid" style={{ marginTop: "100px", width: "95vw", marginLeft: 0 }}></hr>
        <div id="manualCalculator" style={{ paddingTop: "100px", fontSize: "24px" }}>
          Manual Calculator
          <div>
            <TextField
              id="TotalRawDamage" label="Total Damage:" variant="standard" type="number" name="Buff Mult"
              sx={{ input: { color: 'aliceblue', borderBottom: "2px solid #ffffff" }, label: { color: 'aliceblue' }, maxWidth: '20ch' }} />
            <TextField
              id="RawDPS" label="DPS:" variant="standard" type="number" name="Buff Mult"
              sx={{ input: { color: 'aliceblue', borderBottom: "2px solid #ffffff" }, label: { color: 'aliceblue' }, maxWidth: '20ch', marginLeft: "25px" }} />
            <TextField
              id="rDPS" label="rDPS:" variant="standard" type="number" name="Buff Mult"
              sx={{ input: { color: 'aliceblue', borderBottom: "2px solid #ffffff" }, label: { color: 'aliceblue' }, maxWidth: '20ch', marginLeft: "25px" }} />
            <TextField
              id="ExtraDamage" label="Extra Flat Damage:" variant="standard" type="number" name="Buff Mult" defaultValue='0'
              sx={{ input: { color: 'aliceblue', borderBottom: "2px solid #ffffff" }, label: { color: 'aliceblue' }, maxWidth: '20ch', marginLeft: "25px" }} />
            <TextField
              id="BuffMult" label="Buff Mult (i.e. 5% = 1.05):" variant="standard" type="number" name="Buff Mult" defaultValue='1'
              sx={{ input: { color: 'aliceblue', borderBottom: "2px solid #ffffff" }, label: { color: 'aliceblue' }, maxWidth: '20ch', marginLeft: "25px" }} />
            <Button style={{ marginLeft: "25px" }} variant="outlined" id="submit" color="primary" type="submit" onClick={this.manualCalc}>Cope!</Button>
          </div>
          <div style={{ marginTop: "25px", fontSize: "24px", color: "#ec4775" }}>
            New rDPS: {this.state.manual_calc}
          </div>
        </div>
      </div>
    );
  }
}

export default WhatIf;
